import { Component, ElementRef, OnInit , ViewChild } from '@angular/core';
import { UploadServiceService } from '../service/upload-service.service';
import * as uuid from 'uuid';
import { ActivatedRoute } from '@angular/router';
import { firstValueFrom } from 'rxjs';
import { ProfessionServicesService } from '../services/profession-services.service';

@Component({
    selector: 'app-question-creator',
    templateUrl: './question-creator.component.html',
    styleUrls: ['./question-creator.component.css'],
    standalone: false,
})
export class QuestionCreatorComponent implements OnInit {

  @ViewChild('optionInput') myInputVariable!: ElementRef<HTMLInputElement>; 
  
  constructor(private _uploadService:UploadServiceService,private route: ActivatedRoute,private professionService : ProfessionServicesService) { }
  /* editor */
  /* variables */
  gradeSelected;
  questionTypeSelected;
  timelineSelected;
  questionTitle;
  questionSubType;
  subTypeSelected;
  questionId:string;
  optionId:string;
  optionText:string="";
  optionMediaUrl:string="";
  questionContent:String;
  display = "none";
  isChecked =  true;
  files: File[] = null;
  questionMediaUrl:Array<String> =[];
  optionsArray:any=[];
  subTypes:any = []

  selectedTypeMetaData: any = null;
  requireOptionContext = false;
  optionContext: string = "";
  behaviorCategories: any[] = [];
  isLoadingCategories = false;
  selectedBehaviorCategory: string = "";

  grades: any = [
    {value: 1, viewValue: 'Level 1'},
    {value: 2, viewValue: 'Level 2'},
    {value: 3, viewValue: 'Level 3'},
    {value: 4, viewValue: 'Level 4'},
    {value: 5, viewValue: 'Level 5'},
    {value: 6, viewValue: 'Level 6'},
    {value: 7, viewValue: 'Level 7'},
    {value: 8, viewValue: 'Level 8'}
  ];
  times: any = [
    {value:  1, viewValue: '1 Min(s)'},
    {value:  2, viewValue: '2 Mins'},
    {value:  3, viewValue: '3 Mins'},
    {value:  4, viewValue: '4 Mins'},
    {value:  5, viewValue: '5 Mins'},
    {value:  6, viewValue: '6 Mins'},
    {value:  7, viewValue: '7 Mins'},
    {value:  8, viewValue: '8 Mins'}
  ];
  questionTypes :any = [
    {value: 'cognitive-test', viewValue: 'Cognitive Test'},
    {value: 'math', viewValue: 'Math'},
    {value: 'patterns', viewValue: 'Patterns'}
  ]

  async ngOnInit(): Promise<void> {
    // Load behavior categories first
    await this.loadBehaviorCategories();

    this.questionId = this.route.snapshot.queryParamMap.get('questionId');
    if(this.questionId!=null && this.questionId!=undefined && this.questionId!=""){
      this._uploadService.getQuestionById(this.questionId).subscribe((data)=>{
        if(data){
          this.gradeSelected = data["resp"]["grade"]
          this.questionTypeSelected = data["resp"]["typeId"]
          this.timelineSelected = data["resp"]["timeline"]
          this.questionTitle = data["resp"]["questionTitle"]
          this.questionContent = data["resp"]["questionContent"]
          this.questionMediaUrl = data["resp"]["questionMedia"]
          this.optionsArray = data["resp"]["options"]
          this.subTypeSelected = this.loadSubtypesAndSelect(data["resp"]["typeId"], data["resp"]["subTypeId"] || data["resp"]["level"] || "");
          this.updateTypeMetaFlags();
        }
      });
    }else{
      this.questionId = uuid.v4(); // get it from questionId
    }
    console.log("This is the questionID",this.questionId);
    this._uploadService.getAllTypes().subscribe((data)=>{
      if(data){
        this.questionTypes = data["resp"];
        this.updateTypeMetaFlags();
      }
    })
  }

  async loadBehaviorCategories(): Promise<void> {
    this.isLoadingCategories = true;
    try {
      const response: any = await firstValueFrom(
        this.professionService.getBehaviorOptionCategories()
      );
  
      if (response?.success && response?.allBehaviorCategories) {
        this.behaviorCategories = response.allBehaviorCategories || [];
      } else {
        this.behaviorCategories = [];
      }
    } catch (error) {
      console.error('Error loading behavior categories:', error);
      alert('Failed to load behavior categories. Please try again.');
    } finally {
      this.isLoadingCategories = false;
    }
  }

  private updateTypeMetaFlags(){
    const t = (this.questionTypes || []).find(x => x.typeId === this.questionTypeSelected);
    this.selectedTypeMetaData = t?.metaData ?? null;
    // Rule: only when metaData exists AND metaData.evaluation === false we require context
    this.requireOptionContext = !!this.selectedTypeMetaData && this.selectedTypeMetaData.evaluation === false;
  }

  onQuestionTypeChanged(typeId: string){
    this.questionTypeSelected = typeId;
    this.updateTypeMetaFlags();
    this.getSubTypes();
  }

  onSubmit(){
    // let uploadStatus = this.fileUpload();
    // setup the object
      let questionObject = {
        "questionId":this.questionId,
        "grade":this.gradeSelected,
        "questionType":this.questionTypeSelected,
        "timeline":this.timelineSelected,
        "questionTitle":this.questionTitle,
        "questionContent":this.questionContent,
        "questionMedia":this.questionMediaUrl,
        "options":this.optionsArray,
        "subTypeId":this.subTypeSelected,
        "flow_selected":"create-question"
      }
      console.log("Final Object",JSON.stringify(questionObject));
      this._uploadService.createQuestion(JSON.stringify(questionObject)).subscribe((data)=>{
        if(data){
          console.log("Successfully created question");
          alert("Question uploaded successfully");
        }
      })
  }

  onContentChanged(htmlContent: string) {
    // Now you have the complete HTML string in htmlContent
    console.log(htmlContent);
    // Use it for further processing or storage
  }
  onOptionTextChanged(optionText:string){
    console.log("optionTextUpdated",optionText)
    this.optionText = optionText;
  }

  onFileAdd(event) {
    //console.log(event.target.files);
    if(this.files == null)this.files = event.target.files;
    else this.files = Array.from(this.files).concat(Array.from(event.target.files));
    console.log(this.files);
  }

  removeFile(fileName){
    let temp: File[] = [];
    for(let i=0; i<this.files.length; i++){
      if(this.files[i].name != fileName)temp.push(this.files[i]);
    }

    this.files = temp;
  }

  fileUpload(){

    if(this.files != null && this.files.length > 0){
      let temp = [];
      for(let i=0; i<this.files.length; i++){
        let file = this.files[i];
        let extension = file.type.split("/");
        let type = extension[extension.length - 1];
        //console.log("type of file: ", type);
  
         this._uploadService.getUploadURL("konvac/questions/"+this.questionId+"/question_"+i, type).subscribe(urlData => {
          //console.log(data);
          urlData = JSON.parse(urlData.body);
          const uploadURL = urlData.uploadURL;
  
           this._uploadService.postImageOnS3(uploadURL, file, type).subscribe(data => {
            console.log(data);
            temp.push("done");
            this.questionMediaUrl.push(uploadURL.split("?")[0]);
            //if(data != null)window.alert("Something went wrong");
            // if(i == this.files.length-1) {
            //   location.reload();
            // }
            if(temp.length == this.files.length) {
              console.log("Successfully Uploaded files")
               this.questionMediaUrl;
               this.files=null;
               alert("Files uploaded successfully")
            }
          });
        });
      }
    } else {
      console.log("No files to upload");
      alert("Files upload failed");
    }
  }

  optionMediaUrlFn(event){
      // let questionId = "test-1";
      this.optionId = (this.optionId)?this.optionId:this.getAvailableOptionId();
      let optionId = this.optionId;
      let optionFile = event.target.files;
      let file = optionFile[0];
      let extension = file.type.split("/");
      let type = extension[extension.length - 1];
      //console.log("type of file: ", type);

      this._uploadService.getUploadURL("konvac/questions/"+this.questionId+"/options_"+optionId, type).subscribe(urlData => {
        //console.log(data);
        urlData = JSON.parse(urlData.body);
        const uploadURL = urlData.uploadURL;

        this._uploadService.postImageOnS3(uploadURL, file, type).subscribe(data => {
          console.log(data);
            console.log("Successfully Uploaded files");
            this.optionMediaUrl = uploadURL.split("?")[0];
            console.log("Option Media Url",this.optionMediaUrl);
        });
      });
  }

  editOption(option){
    this.optionText = option.text;
    this.optionMediaUrl = option.mediaUrl;
    this.isChecked = (option.answer.length>0)?true:false;
    this.optionId= option.id;
    
    // Load behavior category if it exists
    if(option.metadata?.behaviorCategory) {
      this.selectedBehaviorCategory = option.metadata.behaviorCategory;
    } else if(option.metadata?.context) {
      // Fallback for old context-based approach
      this.optionContext = option.metadata.context;
    }
    
    this.openModal()
  }
  
  dropOption(id){
    console.log("Dropping the created option",id);
    this.optionsArray =this.optionsArray.filter((option)=>option.id!=id);
  }

  openModal() {
    this.display = "block";
  }
  onCloseHandled() {
    this.reset();
    this.optionContext = "";
    this.selectedBehaviorCategory = "";
    this.display = "none";
  }
  addOption(){
    console.log("This is the option",this.optionText);
    console.log("This is media url",this.optionMediaUrl);
    console.log("This is the optionId",this.getAvailableOptionId());
    console.log("Is this correct",this.isChecked);
    if((this.optionMediaUrl && this.optionMediaUrl!="") || (this.optionText && this.optionText!="")){
      if(this.optionId){
        this.dropOption(this.optionId);
      }
      
      const payload:any = {
        id:(this.optionId)?this.optionId:this.getAvailableOptionId(),
        text:this.optionText,
        mediaUrl:this.optionMediaUrl,
        answer:(this.isChecked)?true:false
      };

      if(this.requireOptionContext){
        // Use behavior category instead of free text context
        if(this.selectedBehaviorCategory) {
          payload.metadata = { behaviorCategory: this.selectedBehaviorCategory };
        } else {
          alert("Please select a behavior category for this option");
          return;
        }
      }

      this.optionsArray.push(payload);
    }else{
      console.log("cannot be pushed");
      alert("Either Text or Media should be present")
    }
    
    this.optionId=null;
    this.optionText = "";
    this.optionMediaUrl=""  
    this.isChecked=false;
    this.optionContext = "";
    this.selectedBehaviorCategory = "";
    // this.reset()
    this.onCloseHandled()

  }

  getAvailableOptionId(){
    //potential bug
    let idArray = this.optionsArray.map((option)=>option.id)
    console.log("id array",idArray)
    idArray=idArray.sort((a,b)=>a-b);
    if(idArray.length==0){
      return 1;
    }
    return idArray[idArray.length-1]+1;
  }

  reset() {
    // clear the input so selecting the same file triggers (change)
    if (this.myInputVariable?.nativeElement) {
      this.myInputVariable.nativeElement.value = '';
    }
  }

  removeImage(mediaUrl){
    this.questionMediaUrl = this.questionMediaUrl.filter((qMUrl)=>qMUrl!==mediaUrl);
  }

  getSubTypes(){
    if(this.questionTypeSelected){
      this._uploadService.getAllSubtypesByType(this.questionTypeSelected).subscribe((data)=>{
        if(data && "resp" in data){
          console.log("Subtypes",data["resp"])
          this.subTypes = data["resp"]
        }
        else{
          alert("Seems like type does not have subType, please add");
        }
        // alert("Seems like type does not have subType, please add");
      })
    }else{
      // alert("Please select a type");
    }
  }

  loadSubtypesAndSelect(typeId: string, selectedSubTypeId: string) {
    this._uploadService.getAllSubtypesByType(typeId).subscribe((data) => {
      if (data && "resp" in data) {
        this.subTypes = data["resp"];
        this.subTypeSelected = selectedSubTypeId;
      }
    });
  }
}